import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { VEND_PO_DOC_REPORT } from "./actionTypes";
import { apiError, VendPODocReportSuccessful } from "./actions";

import {
  // postAdd,
  getList,
  // getParamsList,
  // getDownloadFile,
  // postEdit,
  // postDelete,
  // getRowData,
} from "../../helpers/Helper";

function* GetVendPODocReport({ payload: { POToken } }) {
  try {
    const response = yield call(getList, "/purchaseorder/token/" + POToken);

    yield put(VendPODocReportSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
export function* watchPODocReport() {
  yield takeEvery(VEND_PO_DOC_REPORT, GetVendPODocReport);
}
function* VendorPOSaga() {
  yield all([fork(watchPODocReport)]);
}

export default VendorPOSaga;
